import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosInstanceService } from "../services/axiosInstance";
import { apiRoute } from "../util/constant";



export const pushEmailClientSI = createAsyncThunk(
    'task/pushEmailClientSI',
    async ({ shipmentId }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.post(apiRoute.pushEmailClientSI, 
                shipmentId,
            )
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);



export const pushEmailCompanySI = createAsyncThunk(
    'task/pushEmailCompanySI',
    async ({ shipmentId }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.post(apiRoute.pushEmailCompanySI, 
                shipmentId,
            )
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);




export const pushEmailSIAll = createAsyncThunk(
    'task/pushEmailSIAll',
    async ({ shipmentId }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.post(apiRoute.pushEmailSIAll, 
                shipmentId,
            )
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);
